import React from "react";
import { Box, Image, ResponsiveContext } from "grommet";
export var Banner = function Banner(_ref) {
  var cover = _ref.cover,
    _ref$bottom = _ref.bottom,
    bottom = _ref$bottom === void 0 ? "-5.5%" : _ref$bottom,
    _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? "470px" : _ref$maxHeight,
    _ref$minHeight = _ref.minHeight,
    minHeight = _ref$minHeight === void 0 ? "180px" : _ref$minHeight;
  return /*#__PURE__*/ React.createElement(
    "div",
    null,
    /*#__PURE__*/ React.createElement(ResponsiveContext.Consumer, null, function (size) {
      return /*#__PURE__*/ React.createElement(
        Box,
        {
          margin: {
            bottom: bottom,
          },
          height: {
            max: maxHeight,
            min: minHeight,
          },
        },
        /*#__PURE__*/ React.createElement(Image, {
          src: cover,
          fit: "cover",
          style: {
            width: "100%",
          },
        })
      );
    })
  );
};
